/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Start_FailedInputs */



/**
* | output |
* | --- |
* | "We could not start the practice conversation. Please try again in a moment." |
*
* @param {Practice_Start_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_start_failed = /** @type {((inputs?: Practice_Start_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Start_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden het oefengesprek niet starten. Probeer het zo meteen opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu démarrer l'entretien d'entraînement. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("We could not start the practice conversation. Please try again in a moment.")
});